import { useRouter } from "next/router";
import { Form } from "react-bootstrap";
import { useTranslation } from "next-i18next";
// STYLE
import s from "./DropdownCustomItem.module.scss";
import fallbackTranslation from "@/lib/dbTranslations";

interface DropdownCustomItemProps {
  filterType: string;
  item: any;
  multipleSelection: boolean;
  redirectPage: string;
  type: any;
}

export default function DropdownCustomItem({ type, filterType, redirectPage, multipleSelection, item }: DropdownCustomItemProps) {
  const { t } = useTranslation(["common", "db-translations"]);

  const router = useRouter();

  //Add a new filter if the same isn't already in
  function onAddFilter() {
    let queryToUpdate = {};

    // Not firing route.push when mounting the component or when array is empty
    if (!router.query[filterType]) {
      queryToUpdate = { [filterType]: item.key };
    } else if (!router.query[filterType].toString().split(",").includes(item.key)) {
      if (multipleSelection) {
        // build the new query to update
        queryToUpdate = { [filterType]: router.query[filterType] + "," + item.key };
      } else {
        // build the new query to update
        queryToUpdate = { [filterType]: item.key };
      }
    } else {
      //If filter is empty must clear
      if (router.query[filterType].toString().split(",").length > 1) {
        queryToUpdate = {
          [filterType]: router.query[filterType]
            .toString()
            .split(",")
            .filter((val) => {
              return val != item.key;
            })
            .toString(),
        };
      }
    }

    // Clear up the current query, in order to fetch the new one
    delete router.query[filterType];

    // If Category dropdown, pathname and query are different from sizes, colors and order by filters.
    if (filterType == "category") {
      router.push({
        pathname: "/" + redirectPage + "/" + (queryToUpdate[filterType] || "ALL_PRODUCTS"),
        query: { Page: "1" },
      });
    }
    // Clean router.query from "sizes" key, so it can retrieve all the updates items from sizesFilter each time
    else {
      router.push({
        pathname: "/" + redirectPage + "/" + router.query?.category,
        query: { ...router.query, ...queryToUpdate, Page: "1" },
      });
    }
  }
  return (
    <div style={{ cursor: "pointer" }} className={`py-2 ${s.item}`} onClick={onAddFilter}>
      <Form.Check className={`d-flex align-items-center w-100 ms-3 ${s.checkbox}`} aria-label={item.key.toLowerCase()}>
        <Form.Check.Input
          onChange={onAddFilter}
          type={type}
          name="filterCheckbox"
          checked={router.query[filterType] ? router.query[filterType].toString().split(",").includes(item.key) : false}
        />
        <Form.Check.Label>
          <p className="ps-3 mb-0 fw-medium" style={{ cursor: "pointer" }}>
            {filterType == "category" && fallbackTranslation("clothing-product-group", "db-translations", item, t, router.locale)}
            {filterType == "sizes" && fallbackTranslation("sizes", "db-translations", item, t, router.locale)}
            {filterType == "colors" && fallbackTranslation("colors", "db-translations", item, t, router.locale)}
            {filterType == "orderBy" && t("order-by." + item.key.toLowerCase(), { ns: "common" })}
          </p>
        </Form.Check.Label>
      </Form.Check>
    </div>
  );
}
